export default function getRoomsWithPackages({ rooms, packages }) {
  return [...rooms]
    .reverse()
    .filter((room, roomIndex) => Boolean(packages[roomIndex]));
}
